import React from "react";
import { useSelector } from "react-redux";
import { DragescentState } from "../../../store/reducers/stateType";

const ArmyCapacityDetail = () => {
  const armyCapacityUsage = useSelector(
    (state: DragescentState) => state.governorate.armyCapacityUsage
  );

  return (
    <>
      <h3 className="title">Army limits</h3>
      Units: {armyCapacityUsage.armyUnits} / {armyCapacityUsage.armyUnitsLimit}<br />
      Regiments: {armyCapacityUsage.activeRegiments} / {armyCapacityUsage.regimentsLimit}
    </>
  )
};

export default ArmyCapacityDetail;
